import closeIcon from '@/components/Icons/Modals/IconClose.vue';
// import logoutIcon from '@/components/icons/IconLogout.vue';
// import leftArrowIcon from '@/components/icons/IconLeftArrow.vue';
// import { EventBus } from '@/assets/static/event-bus.js';

export default{
	mounted(){
		// this.id = this.$parent.itemClicked;
		setTimeout(() => this.modalActive = true, 300);
	},

	data(){
		return{
			id: null,
			modalActive: false,
			// deleteConfirmed: false,
			responseReady: false,
			success: '',
			email : "",

			language_option: 'es'
		}
	},

	// props: ['section'],
	
	components:{
		closeIcon,
		// leftArrowIcon,
		// logoutIcon
	},

	methods:{
		closeModal(){
			// this.modalActive = false;
			this.$parent.modal_recoverPassword = false;
		},
		recoverPassword(scope){
			
			this.$validator.validateAll(scope).then((result) => {

				if (result) {
					(async () => {
						var rawResponse = await fetch('https://sandbox.api.salonacme.com/manager/email', {
							method: 'POST',
							headers: {
								'Accept': 'application/json',
								'Content-Type': 'application/json'
							},
							body: JSON.stringify({
								email: this.email,
							})
						});
						const content = await rawResponse.json();
						if(content.status){
							this.$parent.modal_recoverPassword = false;
							/** Alerta */
							this.$parent.alert_temp = { status: true,
								type: "success",
								label: content.msg
							};
							setTimeout(() => {
								this.$parent.alert_temp.status = false;
							}, 3000);
							/** FIN Alerta */
						}
						else{
							/** Alerta */
							this.$parent.alert_temp = { status: true,
								type: "warning",
								label: content.msg
							};
							setTimeout(() => {
								this.$parent.alert_temp.status = false;
							}, 3000);
							/** FIN Alerta */
						}
						// alert(content.msg);
							// this.$parent.notify(content.msg);
					})();
				}

			});

		}
	}
}